import { render, staticRenderFns } from "./SectionRowGallery.vue?vue&type=template&id=b38ab690&"
import script from "./SectionRowGallery.vue?vue&type=script&lang=ts&"
export * from "./SectionRowGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports